class EventStorage {
    private events: any[] = [];

    push(e: any) {
        this.events.push(e)
    }

    drain(): any[] {
        const events = this.events;

        this.events = [];

        return events;
    }
}

const sendEvents = (eventStorage: EventStorage, url: string, token: string, sessionId: string): Promise<void> => {
    const events = eventStorage.drain();
    if (events.length === 0) {
        return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
        fetch(`${url}/dniEvents`, {
            method: 'POST',
            body: JSON.stringify({
                token,
                events,
                sessionId,
            }),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            })
        })
        .then(() => resolve())
        .catch((err) => {
            // noop? We can't report the error.
            console.error(err);
            reject(err);
        });
    });
}

export const initEventStorage = (): EventStorage => {
    const eventStorage = new EventStorage();

    const pushDecoratedEvent = (kind: string) => (e: CustomEvent<any>) => {
        eventStorage.push({
            ...e.detail,
            date: new Date().toISOString(),
            kind,
        })
    }

    window.addEventListener('800dni.asc-datalayer', pushDecoratedEvent('asc_datalayer'));
    window.addEventListener('800dni.asc-event', pushDecoratedEvent('asc_event'));
    window.addEventListener('800dni.ga-session', pushDecoratedEvent('ga_session'));
    window.addEventListener('800dni.ga-client', pushDecoratedEvent('ga_client'));
    window.addEventListener('800dni.page_view', pushDecoratedEvent('page_view'));
    window.addEventListener('800dni.swap', pushDecoratedEvent('swap'));
    window.addEventListener('800dni.error', pushDecoratedEvent('error'));

    return eventStorage;
}

export const initEventTracker = (eventStorage: EventStorage, url: string, token: string, sessionId: string) => {
    const sendEventsPeriodically = async () => {
        await sendEvents(eventStorage, url, token, sessionId);    
        setTimeout(sendEventsPeriodically, 1000);
    }

    setTimeout(sendEventsPeriodically, 100);
}